// extracted by mini-css-extract-plugin
export default {"ring":"progressRing_ring__vT7va","track":"progressRing_track__pV1AF","fill":"progressRing_fill__x2KAD","label":"progressRing_label__JcFSe"};